<div class="container">
  <mat-spinner class="spinner"></mat-spinner>

  <div>Loading document...</div>
</div>
